var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19153 8.01014C4.03652 8.00652 3.88923 7.94484 3.78152 7.83849L0.171539 4.40585C0.0616032 4.29891 0 4.15511 0 4.00536C0 3.85561 0.0616032 3.71182 0.171539 3.60487C0.282003 3.50064 0.431111 3.44218 0.586517 3.44218C0.741923 3.44218 0.891063 3.50064 1.00153 3.60487L4.20154 6.64659L11.0015 0.162693C11.112 0.0584626 11.2611 0 11.4165 0C11.5719 0 11.721 0.0584626 11.8315 0.162693C11.9414 0.269636 12.0031 0.413431 12.0031 0.563182C12.0031 0.712933 11.9414 0.856699 11.8315 0.963643L4.61151 7.83849C4.50279 7.94221 4.35534 8.00053 4.20154 8.0006L4.19153 8.01014Z",
    fill: "#000106"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.73828d32d0ded2fab97bf9bdd871b348.svg";
export { ForwardRef as ReactComponent };